import cx from 'classnames';
import PropTypes from 'prop-types';

import { ChannelIcon } from 'src/components/ChannelIcon';
import { CustomButtonBase } from 'src/components/CustomButtonBase';
import { CHANNEL, getChannelPerformanceLabel } from 'src/data/channel';

import { useStyles } from './useStyles';

export const ChannelButton = ({ className, channel, label, onClick, ...restProps }) => {
  const styles = useStyles();

  return (
    <CustomButtonBase
      className={cx(styles.root, className)}
      onClick={() => onClick(channel)}
      data-testid={`channelButton_${channel}`}
      {...restProps}
    >
      <ChannelIcon
        className={styles.icon}
        channel={channel}
      />

      {label || getChannelPerformanceLabel(channel)}
    </CustomButtonBase>
  );
};

ChannelButton.propTypes = {
  className: PropTypes.string,
  channel: PropTypes.oneOf(Object.values(CHANNEL)).isRequired,
  label: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};
ChannelButton.defaultProps = {
  className: null,
  label: null,
};
